import { useGate, useStore, useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import {
  DocumentBasedRegistration,
  documentBasedRegistrationStepModel,
  useTitle,
} from '~/features/DocumentBasedRegistration'
import { driverModel } from '~/entities/Driver'
import { PageContainer } from '~/shared/ui/PageContainer'
import { SuccessStep } from './SuccessStep'

export const LeadDocumentBasedRegistrationPage = () => {
  useGate(documentBasedRegistrationStepModel.Gate)

  const defaultValues = useStoreMap(driverModel.$driver, (driver) => ({
    phone: driver?.getPhone(),
  }))

  const correctionDefaultValues = useStoreMap(
    driverModel.$driver,
    (driver) => ({
      firstName: driver?.getFirstName(),
      middleName: driver?.getMiddleName(),
      lastName: driver?.getLastName(),
    }),
  )

  const {
    isDriverLicenseStep,
    isAdditionalDataStep,
    isConfirmCodeStep,
    isCorrectionStep,
    isErrorStep,
  } = useStore(documentBasedRegistrationStepModel.$currentStepFlags)

  const title = useTitle()

  const pageContainerProps = useMemo(() => {
    return {
      ...(isDriverLicenseStep || isAdditionalDataStep
        ? { onBack: documentBasedRegistrationStepModel.goToBackStep }
        : {}),
      ...(isConfirmCodeStep
        ? {
            contentFillColor: null,
            onBack: documentBasedRegistrationStepModel.goToBackStep,
          }
        : {}),
      ...(isErrorStep
        ? { onBack: documentBasedRegistrationStepModel.goToConfirmStep }
        : {}),
      ...(isCorrectionStep
        ? { onBack: documentBasedRegistrationStepModel.goToBackStep }
        : {}),
    }
  }, [
    isAdditionalDataStep,
    isConfirmCodeStep,
    isDriverLicenseStep,
    isErrorStep,
    isCorrectionStep,
  ])

  return (
    <PageContainer
      title='Регистрация'
      backTitle={title}
      canBack
      {...pageContainerProps}
    >
      <DocumentBasedRegistration
        SuccessStep={SuccessStep}
        additionalDataDefaultValues={defaultValues}
        correctionDefaultValues={correctionDefaultValues}
        disabledChangePhone
      />
    </PageContainer>
  )
}
